import { PayloadAction } from '@reduxjs/toolkit';
import { message } from 'antd';

let previousError: '';
export const defaultReducers = {
  getStart(state) {
    state.loading = true;
    state.error = '';
  },
  getSuccess(state, action: PayloadAction<any>) {
    state.loading = false;
    state.error = '';
    if (action.payload) {
      Object.assign(state, action.payload);
    }
  },
  getFailure(state, action: PayloadAction<any>) {
    state.loading = false;
    const payload = action.payload || {};
    // Conflict handlers already showed a warning toast — don't also message.error
    // with a mangled body (e.g. 409 participant_conflict + [object Object]).
    if (payload.silentFailure || payload.isConflict) {
      state.error = payload.message || '';
      return;
    }
    const raw =
      typeof payload.message === 'string'
        ? payload.message
        : payload.message != null
        ? String(payload.message)
        : 'Error Completing Request';
    state.error = raw;
    const error = raw.substring(0, 300);
    if (error !== previousError) {
      message.error(error);
    }
    previousError = error;
    // Prevent duplicate errors from the past few seconds from showing up
    setTimeout(() => {
      previousError = '';
    }, 3000);
  },
  add(state, action: PayloadAction<any>) {
    state.loading = false;
    state.error = '';
    state.list.push(action.payload.id);
    state.byId[action.payload.id] = action.payload;
  },
  update(state, action: PayloadAction<any>) {
    state.loading = false;
    state.error = '';
    state.byId[action.payload.id] = action.payload;
  },
  delete(state, action: PayloadAction<any>) {
    state.loading = false;
    state.error = '';
    state.list.splice(
      state.list.findIndex((id) => {
        return id === action.payload.id;
      }),
      1
    );
    delete state.byId[action.payload.id];
  },
  normalizeList(state, action: PayloadAction<any>) {
    state.loading = false;
    const byId = {};
    (action.payload || []).forEach((item) => {
      byId[item.id] = item;
    });
    state.list = (action.payload || []).map((item) => {
      return item.id;
    });
    state.byId = byId;
  },
};
